
export const policiesAction = {
    visualizzazione: "Visualizzazione",
    esportazione:"Esportazione",
    inserimentoModifica:"InserimentoModifica",
    resetPassword:"ResetPassword",
}

export const policies = {
dashboardVisualizzazione: "Dashboard.Visualizzazione",
utentiVisualizzazione:"Utenti.Visualizzazione",
utentiEsportazione:"Utenti.Esportazione" ,
utentiInserimentoModifica:"Utenti.InserimentoModifica" ,
utentiEliminazioneRipristino:"Utenti.EliminazioneRipristino" ,
utentiResetPassword:"Utenti.ResetPassword",
dispositiviEsportazione:"Dispositivi.Esportazione" ,
dispositiviVisualizzazione:"Dispositivi.Visualizzazione" ,
dispositiviInserimentoModifica:"Dispositivi.InserimentoModifica" ,
chiamataVisualizzazione:"Chiamata.Visualizzazione" ,
chiamataEsportazione:"Chiamata.Esportazione"
}